// Components
import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/layouts/Home.vue'
import MainPage from '@/views/MainPage.vue'
import NotFoundPage from '@/views/NotFoundPage.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
import TermsOfService from '@/views/TermsOfService.vue'

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0, left: 0 }),
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '/',
          component: MainPage,
          beforeEnter(to, from, next) {
            // расширение шлёт на /?auth=true, когда view ещё нет: показываем вход, не лендинг
            if (to.query.auth === 'true') return next('/id')
            window.location.href = process.env.VUE_APP_LANDING
          },
        },
        {
          path: '/id',
          component: MainPage,
        },
        {
          path: '/id/:id',
          name: 'main',
          component: MainPage,
        },
        {
          path: '/privacy',
          name: 'privacy',
          component: PrivacyPolicy,
        },
        {
          path: '/tos',
          name: 'tos',
          component: TermsOfService,
        },
        {
          path: '/r/:id',
          component: NotFoundPage,
          props: {
            errorData: {
              name: 'oldLink',
            },
          },
        },
        // Всё остальное (в т.ч. убранные /account и /subscribe) — страница 404
        {
          path: '/:pathMatch(.*)*',
          component: NotFoundPage,
        },
        /** support old links */
        {
          path: '/engagement',
          component: MainPage,
          beforeEnter(to, from, next) {
            const urlSearchParams = new URLSearchParams(to.fullPath)
            const sites = urlSearchParams.get('sites')
            if (!sites) return
            window.location.href = `/id?domains=${sites}`
          },
        },
      ],
    },
  ],
  components: {
    Home,
    MainPage,
  },
})

router.beforeEach((to, from, next) => {
  document.body.setAttribute('route', to.name || '')
  next()
})

export default router
